export function isDrivePath(path: string): boolean {
  return (
    path === '/drive'
    || path === '/bg/drive'
    || path === '/en/drive'
    || path.startsWith('/drive/')
    || path.startsWith('/bg/drive/')
    || path.startsWith('/en/drive/')
  )
}
